import { React } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import BackArrowIcon from '../assets/icons/back-arrow-icon';
import { useUpdateURLParams } from 'common-hooks/update-query-params-hooks';
import { responsiveBreakpoints } from 'utils/utils';

export default function Page({
  children,
  heading,
  subHeading,
  subHeading2,
  actions,
  backButtonText,
  backButtonHref,
  backgroundColor,
  backButtonFunc,
  catalogPage,
  isLoading,
}) {
  const navigate = useNavigate();
  const { updateURLParams } = useUpdateURLParams();
  const { theme, mobile, tablet, laptop, desktop, mainWidth } =
    responsiveBreakpoints();

  const loader = (
    <Stack alignItems='center' marginTop={20}>
      <CircularProgress color='primary' />
    </Stack>
  );

  return (
    <Box
      sx={[
        {
          backgroundColor: backgroundColor ?? 'var(--page-background-color)',
          minHeight: '600px',
          // justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        },
        backButtonHref && backButtonText
          ? { padding: '10px 35px 30px 35px' }
          : catalogPage
          ? mobile
            ? { padding: '0px 15px 30px 15px', width: '100vw' }
            : tablet
            ? { padding: '0px 15px 30px 15px', width: '100vw' }
            : {
                padding: '0px ',
              }
          : mobile
          ? { padding: '20px 35px 30px 35px' }
          : tablet
          ? { padding: '20px 35px 30px 35px' }
          : { padding: '20px 0px 30px 0px' },
      ]}
    >
      <Box
        sx={{
          width: mobile ? '100%' : tablet ? '100%' : mainWidth,
        }}
      >
        {backButtonText && backButtonHref ? (
          <Stack
            spacing={1}
            direction='row'
            alignItems='center'
            onClick={(e) => {
              e.preventDefault();
              backButtonFunc ? backButtonFunc() : null;
              navigate(backButtonHref);
            }}
            sx={{ marginBottom: '5px', cursor: 'pointer' }}
          >
            <BackArrowIcon />
            <Typography
              variant='body2'
              sx={{
                color: 'var(--link-color)',
                lineHeight: '1.64',
              }}
            >
              {backButtonText}
            </Typography>
          </Stack>
        ) : null}
        {heading || subHeading || actions.length > 0 || subHeading2 ? (
          <Stack
            direction='row'
            justifyContent='space-between'
            sx={{
              marginBottom: '10px',
              width: '100%',
            }}
          >
            <Stack>
              <Typography variant='h1' sx={{ fontSize: '20px' }}>
                {heading}
              </Typography>

              <Stack direction='row' justifyContent='space-between'>
                {subHeading && (
                  <Typography variant='subtitle1'>{subHeading}</Typography>
                )}
              </Stack>
            </Stack>
            <Stack direction='row' spacing={1} alignItems='end'>
              <Stack direction='row' spacing={2}>
                {actions?.map((item, index) => {
                  return (
                    <Box component='span' key={`${index}+1`}>
                      {item}
                    </Box>
                  );
                })}
              </Stack>

              {subHeading2 && (
                <Typography variant='subtitle1'>{subHeading2}</Typography>
              )}
            </Stack>
          </Stack>
        ) : null}
        {isLoading ? loader : children}
      </Box>
    </Box>
  );
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  subHeading2: PropTypes.any,
  actions: PropTypes.array,
  backButtonText: PropTypes.string,
  backButtonHref: PropTypes.string,
  backgroundColor: PropTypes.string,
  backButtonFunc: PropTypes.func,
  catalogPage: PropTypes.bool,
  isLoading: PropTypes.bool, // to show a page loader
};

Page.defaultProps = {
  heading: '',
  subHeading: '',
  subHeading2: '',
  actions: [],
  backButtonText: null,
  backButtonHref: null,
  backgroundColor: null,
  backButtonFunc: () => {},
  catalogPage: false,
  isLoading: false,
};
